// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import snackbar from './snackbar';
import comModule from './comModule';
import auth, { handleLogout } from './authentication';

// ==============================|| COMBINE REDUCERS ||============================== //

const appReducer = combineReducers({
  menu,
  snackbar,
  comModule,
  auth
});

// ponytail: full store wipe on logout — stops prior-user steps/permissions leaking across SPA login
const reducers = (state, action) => {
  if (handleLogout.match(action)) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default reducers;
